import React, { useState } from "react";
import { Table, Input, Form, Button } from "antd";

const EditableCell = ({ editing, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    rules={[{ required: false }]}
                >
                    <Input />
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

const TradeTable = ({ columns, data, scroll, className }) => {
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");

    const isEditing = (record) => record.key === editingKey;

    const edit = (record) => {
        form.setFieldsValue({ ...record });
        setEditingKey(record.key);
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();
            console.log("Updated row:", row); // handle update
            setEditingKey("");
        } catch (err) {
            console.log("Validation failed:", err);
        }
    };

    const cancel = () => {
        setEditingKey("");
    };



    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: "text",
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });



    return (
        <Form form={form} component={false}>
            <Table
                components={{ body: { cell: EditableCell } }}
                columns={mergedColumns}
                dataSource={data}
                expandable={{ defaultExpandAllRows: true }}
                pagination={false}
                bordered
                className={className}
                scroll={scroll}
            />
        </Form>
    );
};

export default TradeTable;
